import React from 'react';
import ArrowBack from '@material-ui/icons/ArrowBack';
import styled from "styled-components";
import { useHistory } from "react-router";

const ArrowWrapper = styled.button`
    border: 1px solid #bdbdbd;
    display: flex;
    width: fit-content;
    padding: 10px;
    margin-right: 10px;
    background: none;
    &:hover {
        cursor: pointer;
    }
    &:active {
        background-color: #e1e1e1;
    }
`;

function GoBack (props) {
  const history = useHistory();
  const { pathToPush } = props;

    return (
        <ArrowWrapper onClick={()=>history.goBack()
        //     push({
        //     pathname:  `/dashboard/${pathToPush}`
        //   })
        }
          >
            <ArrowBack/>
        </ArrowWrapper>
    )
}

export default GoBack;